module.exports = __webpack_public_path__ + "img/République.3d0a6661.png";